/** Keep endpoint names readable without creating a distinct title for every ID. */
export function requestSpanPath(pathname: string, apiPrefix: string): string {
	const path = `/api/${pathname.slice(apiPrefix.length)}`;
	if (path.startsWith("/api/graph/")) return "/api/graph/{**graphPath}";
	const parameterByCollection: Record<string, string> = {
		students: "studentNumber",
		classes: "classId",
	};
	const segments = path.split("/");
	return segments
		.map((segment, index) => {
			const numeric = /^\d+$/.test(segment);
			const guid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(segment);
			if (!numeric && !guid) return segment;
			return `{${parameterByCollection[segments[index - 1]] ?? "id"}}`;
		})
		.join("/");
}
